export default {
  CHANGE_MULTI_FILTERS: "CHANGE_MULTI_FILTERS",
};
